'use client'

import { sidebarStore } from '@/store/ui/sidebar.store'
import React, { useEffect } from 'react'
import { Button } from './Button'
import { useRouter } from 'next/navigation'
import { memberStore } from '@/store/member.store'
import { memberService } from '@/modules/member'
import { dialog } from '@/modules/ui/dialog'
import { moveToLoginPage } from '@/utils/moveToLoginPage'
import { sidebarActionLog } from '@/modules/action-log/sidebar'
import { useArtistRouter } from '@/hooks/useArtistRouter'
import { FAQ_PAGE_URL, NOTICE_PAGE_URL } from '@/constants/url'
import { ArtistType } from '@/types/artist.type'

export const SideBar = () => {
  const { visible, changeVisible } = sidebarStore()
  const router = useRouter()
  const { memberId } = memberStore()
  const { goArtistLastMainPage, goArtistStockStoryPage, getDivideArtistFirstPathname, getLastPageArtistFirstPathname } =
    useArtistRouter()

  useEffect(() => {
    if (visible) {
      sidebarActionLog.inital()
    }
  }, [visible])

  const isLogin = memberId !== null && memberId !== undefined

  const handleGoMainPage = () => {
    goArtistLastMainPage()
  }

  const handleCloseVisible = () => {
    changeVisible({ visible: false })
  }

  const handleGoLoginBridgePage = () => {
    sidebarActionLog.clickLogin()
    changeVisible({ visible: false })
    moveToLoginPage()
  }

  const handleLogout = async () => {
    const isLogoutConfirmed = await dialog.openMessage({
      title: '로그아웃 하시겠습니까?',
      confirmMessage: '네',
      cancelVisible: true,
      cancelMessage: '아니오',
    })

    if (isLogoutConfirmed) {
      changeVisible({ visible: false })
      memberService.logout()
      goArtistLastMainPage()
    }
  }

  const handleGoStockPage = async () => {
    changeVisible({ visible: false })

    if (!memberService.isLogin()) {
      const confirmLogin = await dialog.openMessage({
        title: '로그인이 필요한 서비스입니다.',
        message: '로그인 하시겠습니까?',
        cancelVisible: true,
        confirmMessage: '네',
        cancelMessage: '아니오',
      })

      if (confirmLogin) {
        moveToLoginPage()

        return
      }
      return
    }

    goArtistStockStoryPage()
  }

  const handleGoSettingPage = async () => {
    changeVisible({ visible: false })

    if (!memberService.isLogin()) {
      const confirmLogin = await dialog.openMessage({
        title: '로그인이 필요한 서비스입니다.',
        message: '로그인 하시겠습니까?',
        cancelVisible: true,
        confirmMessage: '네',
        cancelMessage: '아니오',
      })

      if (confirmLogin) {
        moveToLoginPage()
        return
      }
      return
    }

    const artistFirstPathname = getDivideArtistFirstPathname()

    router.push(`/${artistFirstPathname}/setting`)
  }

  const handleGoNoticePage = () => {
    sidebarActionLog.clickNotice()
    const lastPageArtistFirstPathname = getLastPageArtistFirstPathname()
    const noticePageUrl = NOTICE_PAGE_URL[lastPageArtistFirstPathname as keyof typeof NOTICE_PAGE_URL]
    window.open(noticePageUrl, '_blank')
  }

  const handleGoFaqPage = () => {
    sidebarActionLog.clickFaq()
    const lastPageArtistFirstPathname = getLastPageArtistFirstPathname()
    const faqPageUrl = FAQ_PAGE_URL[lastPageArtistFirstPathname as keyof typeof FAQ_PAGE_URL]
    window.open(faqPageUrl, '_blank')
  }

  return (
    <>
      <div
        className={`absolute inset-0 bg-black/70 bg-opacity-50 z-40 transition-opacity duration-300
          ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={handleCloseVisible}
      />
      <aside
        className={`absolute top-0 right-0 h-full w-[320px] bg-white border-l border-gray-200 z-50
          transform transition-transform duration-300 ease-in-out
          ${visible ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex items-center px-[16px] py-[16px]">
          <div className="flex items-center">
            {/* <button className="cursor-pointer">
              <img src="/img/arrow_left.svg" />
            </button> */}
          </div>
          <div className="flex-1">{/* <p className="text-h400 text-black text-center">타이틀</p> */}</div>
          <div className="flex items-center">
            <button className="cursor-pointer" onClick={handleCloseVisible}>
              <img src="/img/close_black.svg" />
            </button>
          </div>
        </div>
        <div className="flex w-full px-[20px] py-[16px]">
          {!isLogin && (
            <Button onClick={handleGoLoginBridgePage} color="secondary" fullWidth>
              로그인/회원가입
            </Button>
          )}
          {isLogin && (
            <div className="flex flex-col gap-[16px] w-full">
              <p className="text-black text-body3_strong">{memberId}</p>
              <Button onClick={handleLogout} color="secondary" fullWidth>
                로그아웃
              </Button>
            </div>
          )}
        </div>
        <nav className="flex flex-col px-[20px] py-[16px] gap-[24px]">
          <button onClick={handleGoMainPage} className="block text-body1_strong text-[#181818] w-full h-fit text-left">
            홈
          </button>
          <button onClick={handleGoStockPage} className="block text-body1_strong text-[#181818] w-full h-fit text-left">
            보관함
          </button>
          <button
            onClick={handleGoSettingPage}
            className="block text-body1_strong text-[#181818] w-full h-fit text-left"
          >
            설정
          </button>
        </nav>
        <div className="flex flex-col items-center justify-center absolute bottom-0 pb-[50px] w-full gap-[20px]">
          <div className="flex w-full justify-center items-center gap-[16px]">
            <a
              onClick={handleGoNoticePage}
              className="w-[124px] h-[20px] flex items-center justify-center text-center text-body3_strong text-gray-5"
            >
              공지사항
            </a>
            <div className="w-[1px] h-[14px] bg-gray-2" />
            <a
              onClick={handleGoFaqPage}
              className="w-[124px] h-[20px] flex items-center justify-center text-center text-body3_strong text-gray-5"
            >
              FAQ
            </a>
          </div>
          <p className="text-gray-3 text-caption1">고객센터 1599-6034(유료)</p>
        </div>
      </aside>
    </>
  )
}
